
import { Component, Prop, Vue } from 'vue-property-decorator'
import FormContainer from '@/components/processing_steps/commons/forms/FormContainer.vue'
import { ISummaryItem } from '@/types/processingSteps'

@Component({
  components: { FormContainer }
})
export default class SummaryItems extends Vue {
  @Prop() summaryItems!: ISummaryItem[]
  @Prop({ default: null }) summaryDescription!: string | null
}
